<template>
  <v-dialog v-model="dialog" width="1200" persistent>
    <v-card class="no-scroll">
      <v-card-title class="text-h5 grey lighten-2">
        Solicitud
      </v-card-title>
      <v-card-text>
        <v-form ref="formBeneficio">
          <v-row style="padding-top: 30px;">
            <v-col cols="12" md="3">
              <p style="margin-bottom:0px">Buscar cliente por:</p>
              <v-radio-group v-model="filtro" row>
                <v-radio
                  label="Certificado"
                  :value="1"
                  color="#00a7e4"
                ></v-radio>
                <v-radio label="Nombre" :value="2" color="#00a7e4"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="9">
              <v-autocomplete
                :items="emisiones"
                item-text="valor_campo"
                item-value="id"
                v-model="formData.emision_id"
                :search-input.sync="busqueda"
                name="name"
                label="Teclear datos de búsqueda"
                outlined
                primary
                :loading="isLoading"
                clearable
                color="#00a7e4"
                :rules="required"
                @change="handleSelection"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>
                      Tecla el
                      <strong>{{
                        filtro == 1 ? "número de certificado" : "nombre"
                      }}</strong>
                      para buscar
                    </v-list-item-title>
                  </v-list-item>
                </template>
                <template v-slot:append-outer>
                  <v-slide-x-reverse-transition
                    mode="out-in"
                    v-if="alianzas.length > 0"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="primary" dark v-bind="attrs" v-on="on">
                          mdi-help-circle
                        </v-icon>
                      </template>
                      <p style="color: white !important;">
                        Recuerda que solo podrás ver los socios que pertenecen a
                        las siguientes alianzas:
                      </p>
                      <ul
                        v-for="(alianza, index) in aliazas_ids"
                        :key="index"
                        style="color: white !important"
                      >
                        <li>{{ getAlianzaName(alianza) }}</li>
                      </ul>
                    </v-tooltip>
                  </v-slide-x-reverse-transition>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-if="formData.emision_id">
            <v-col cols="12" md="3">
              <v-autocomplete
                :items="origenList"
                name="name"
                label="Origen"
                v-model="formData.origen"
                outlined
                primary
                :rules="required"
                color="#00a7e4"
                disabled
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                :items="tipoSolicitudes"
                name="name"
                label="Tipo"
                item-text="tipo"
                item-value="tipo"
                v-model="formData.tipo"
                outlined
                :rules="required"
                primary
                color="#00a7e4"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" v-if="formData.tipo != null && formData.tipo != 'Siniestros'">
              <v-autocomplete
                :items="tiposOptions"
                name="name"
                label="Asistencia o beneficio"
                v-model="formData.tipo2"
                outlined
                :rules="required"
                primary
                clearable
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-if="formData.tipo!= null && formData.tipo2 != null && (formData.tipo != 'Endoso' && formData.tipo != 'Siniestros')"
            >
              <v-autocomplete
                :items="categoriasOptions"
                name="name"
                label="Categoria"
                clearable
                v-model="formData.categoria"
                outlined
                :rules="required"
                primary
                :disabled="!formData.tipo2"
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" v-if="formData.tipo == 'Siniestros'">
              <v-autocomplete
                :items="siniestros"
                name="name"
                label="Siniestros"
                item-text="nombre"
                item-value="id"
                v-model="formData.siniestro_id"
                outlined
                :rules="required"
                primary
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-if="
                formData.tipo == 'Siniestros' && formData.siniestro_id != null
              "
            >
              <v-text-field
                name="sumaAsegurada"
                label="Suma asegurada maxima"
                v-model="sumaAsegurada"
                outlined
                primary
                :readonly="true"
                :rules="required"
                color="#00a7e4"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if=" (formData.tipo != null && formData.tipo2 != null && formData.categoria != null) && (formData.tipo != 'Endoso' && formData.tipo != 'Siniestros')"
            >
              <v-autocomplete
                :items="beneficiosOptions"
                name="name"
                item-text="nombre"
                item-value="id"
                label="Asistencia / Beneficio"
                v-model="formData.beneficio_asistencia_id"
                outlined
                :rules="required"
                primary
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" v-if="(formData.tipo != null && formData.tipo2 != null && formData.categoria != null && formData.beneficio_asistencia_id != null ) && formData.tipo != 'Siniestros'">
              <v-text-field
                v-model="formData.telefono"
                label="Número a recibir folio"
                outlined
                color="#00a7e4"
                type="tel"
                :rules="required"
                maxlength="10"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-if="
                [1, 17, 20].includes(formData.beneficio_asistencia_id) &&
                  formData.tipo != 'Siniestros'
              "
            >
              <v-text-field
                v-model="formData.telefono_saldo"
                label="Número a canjear beneficio"
                outlined
                color="#00a7e4"
                type="tel"
                :rules="required"
                maxlength="10"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="12"
              v-if="
                formData.tipo == 'Redención' &&
                  formData.tipo2 == 'Asistencia' &&
                  formData.tipo != 'Siniestros'
              "
            >
              <v-autocomplete
                :items="['Titular', 'Familar', 'Titular y familiar']"
                name="name"
                label="La Redención para"
                v-model="formData.redencionPara"
                v-show="producto.limiteFamiliares != null"
                outlined
                :rules="required"
                primary
                color="#00a7e4"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="12"
              v-if="(formData.tipo != null && formData.tipo2 != null) && ((formData.redencionPara == 'Familar' || formData.redencionPara == 'Titular y familiar'))"
            >
              <v-autocomplete
                :items="beneficiarios"
                name="name"
                item-text="valor_campo"
                item-value="id"
                label="Familiar / Beneficiario"
                v-model="formData.beneficiarios"
                outlined
                :rules="[
                  (v) => {
                    if (!isFamiliar) {
                      return !!v || 'Debes seleccionar un beneficiario';
                    }
                    return (
                      (Array.isArray(v) && v.length > 1) ||
                      'Debes seleccionar al menos 1 beneficiarios'
                    );
                  },
                ]"
                primary
                :multiple="isFamiliar"
                color="#00a7e4"
              >
                <template v-slot:append-outer>
                  <v-icon
                    @click="dialogBeneficiarios = true"
                    color="#00a7e4"
                    class="mr-2"
                    style="cursor: pointer;"
                  >
                    mdi-plus-circle
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div>
          <v-row style="text-align: end;">
            <v-col cols="12">
              <v-btn
                text
                color="#00a7e4"
                outlined
                dark
                style="border-radius: 15px;"
                @click="$emit('closeDialog')"
              >
                Cancelar
              </v-btn>
              <v-btn
                class="common-botton"
                dark
                @click="handleSaveBtnClick"
                :loading="loading"
              >
                Guardar
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card-actions>
    </v-card>
    <CreateBeneficiarioModal
      v-if="dialogBeneficiarios"
      :currentPorcentaje="currentPorcentaje"
      :emision_id="Number(formData.emision_id)"
      :dialog="dialogBeneficiarios"
      :cerrarEvento="true"
      @closeModal="closeModalBeneficiario"
    />
    <CommonActionModal
      :dialog="solicitudModal"
      :title="menssageError"
      :subtitle="'Quieres entrar a ver la solicitud'"
      :bottonText="'Si, vamos'"
      @userChoice="toSolicitud"
    />
    <CommonUpdateInputModal 
      :dialog="modalUpdateStatusCivil" 
      :emision_id="formData.emision_id" 
      @success-emision="handleSuccessEmision"
      @closeModal="onCloseModal"
     />
  </v-dialog>
</template>

<script>
import { getAlianzasList } from "@/services/alianzas/alianzas.service.js";
import { getProductoByID } from "@/services/productos/product.service";
import { getEmisionByTitular } from "@/services/emision.service";
import { getAlianzaByEmision } from "@/services/alianzas/alianzas.service";
import { getBeneficiariosByEmisionId } from "@/services/beneficiarios/benefiario.service";
import { getSiniestroByAlianzaId } from "@/services/siniestros/Siniestros";
import CreateBeneficiarioModal from "@/components/commonComponents/dialogs/CreateBeneficiarioModal.vue";
import CommonUpdateInputModal from "@/components/commonComponents/dialogs/CommonUpdateInputModal.vue";
import {
  getCategorias,
  getTipos,
  getBeneficiosByFilters,
} from "@/services/clubBeneficios/clubBeneficios";
import { getTipoSolicitudesForAlianzaId } from "@/services/solicitudes/Solicitudes";
import { mainAxios } from "../../../../../../mainAxios";
import CommonActionModal from "@/components/commonComponents/CommonActionModal.vue";

export default {
  components: {
    CreateBeneficiarioModal,
    CommonActionModal,
    CommonUpdateInputModal
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        redencionPara: null,
        tipo:null,
        tipo2:null,
        origen: "Portal",
        emision_id: 0,
        telefono: null,
        telefono_saldo: null,
        siniestro_id: null,
        beneficiarios: [],
        categoria:null
      },
      origenList: ["Portal", "IVR", "APP", "Correo electrónico"],
      emisiones: null,
      producto: null,
      alianzaSingle: null,
      filtro: 1,
      isLoading: false,
      busqueda: null,
      alianza_intermx_id: null,
      isSelected: false,
      dialogBeneficiarios: false,
      beneficiarios: [],
      categoriasOptions: [],
      tiposOptions: [],
      beneficiosOptions: [],
      siniestros: [],
      tipoSolicitudes: [],
      aliazas_ids: [],
      alianzas: [],
      currentPorcentaje: 0,
      required: [(value) => !!value || "Campo Requerido"],
      beneficiariosRules: [
        (v) =>
          (Array.isArray(v) && v.length > 0) ||
          "Debes seleccionar al menos 1 beneficiario",
      ],
      loading: false,
      existsolicitudID: null,
      solicitudModal: false,
      modalUpdateStatusCivil:false,
      menssageError:''
    };
  },
  mounted() {
    this.getAlianzas();
    this.getCategoriasOptions();
    this.getTiposOptions();
    this.getBeneficiosByFilters();
    this.getTipoSolicitudesForAlianzaId();
    this.aliazas_ids = JSON.parse(
      localStorage.getItem("alianzas_inter_mx") ?? "[]"
    );
  },
  watch: {
    filtro() {
      this.clearFilters();
    },
    busqueda(newVal) {
      if (newVal == null || newVal == "") this.clearFilters();
      if (this.isSelected) return;
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = setTimeout(() => {
        if (newVal && newVal.length > 2) {
          this.isLoading = true;
          this.getEmisionByTitular();
        } else {
          this.emisiones = [];
          this.isLoading = false;
        }
      }, 500);
    },
    "formData.redencionPara"(val) {
      if (val == "Familar" || val == "Titular y familiar") {
        this.getBeneficiariosByEmisionId();
      } else if (val == "Titular") {
        this.formData.beneficiarios = [];
      }
    },
    "formData.tipo2"(val) {
      this.getCategoriasOptions();
      this.getBeneficiosByFilters();
      if (val == "Beneficio") this.formData.redencionPara = "Titular";

      if(val == 'Asistencia' && this.formData.tipo == 'Redención')
          this.validateStatusCivil();

    },
    "formData.categoria"() {
      this.getBeneficiosByFilters();
    },
    "formData.emision_id"() {
      this.fetchAlianzaByEmisionId();
      this.getTipoSolicitudesForAlianzaId();
      this.getBeneficiariosByEmisionId();
    },
    "formData.tipo"(newVal) {
      this.getSiniestroByAlianzaId();
      if(newVal == "Siniestros")
      this.validateStatusCivil();
    },
    "formData.siniestro_id"() {
      this.calculateSumaAsegurada();
    },
  },
  computed: {
    categorias() {
      switch (this.formData.tipo) {
        case "Redención":
          return ["Asistencia", "Beneficio"];
        case "Siniestros":
          return ["Gastos Médicos", "Fallecimiento"];
      }
      return [];
    },
    isFamiliar() {
      let asistencia = this.beneficiosOptions.find(
        (e) => e.id == this.formData.beneficio_asistencia_id
      );
      return asistencia ? (asistencia.familiar ? true : false) : false;
    },
  },
  methods: {
    handleSaveBtnClick() {
      if(this.isBetterware(this.emisiones.filter((e) => e.id == this.formData.emision_id)[0])){
        this.guardarSolicitud();
        return;
      }else{
        this.guardarSolicitudGenerica();
        return;
      }
    },
    clearFilters() {
      this.busqueda = null;
      this.emisiones = null;
      this.formData.emision_id = null;
      this.isSelected = false;
    },
    async getAlianzas() {
      let response = await getAlianzasList();
      this.alianzas = response.data;
    },
    async getEmisionByTitular() {
      this.emisiones = [];
      const filters = {
        alianza_intermx_ids: this.aliazas_ids,
        [this.filtro === 1 ? "certificado" : "titular"]: this.busqueda,
      };
      this.isLoading = true;
      let response = await getEmisionByTitular(filters);
      response.data.map((e) => {
        this.emisiones.push({
          ...e,
          valor_campo: this.getNombreTitularCompleto(e),
        });
      });
      this.isLoading = false;
    },
    async getBeneficiariosByEmisionId() {
      if (this.formData.emision_id) {
        const response = await getBeneficiariosByEmisionId(
          this.formData.emision_id
        );
        let currentPorcentaje = 0;
        this.beneficiarios = [];

        response.data.beneficiarios.map((e) => {
          currentPorcentaje += Number(e.porcentaje) || 0;
          this.beneficiarios.push({
            ...e,
            valor_campo: `${e.nombre || ""} ${e.apellidoPaterno ||
              ""} ${e.apellidoMaterno || ""}`.trim(),
          });
        });

        this.currentPorcentaje = currentPorcentaje;
      }
    },
    handleSelection(value) {
      if (value) {
        this.isSelected = true;
        const emision = this.emisiones.find((e) => e.id === value);
        this.alianzaSingle = this.alianzas.find((a) => a.id == emision?.alianza_intermx_id) ?? null;
        this.formData.telefono = emision?.telefonoContacto || null;
        this.formData.telefono_saldo = emision?.telefonoContacto || null;
        this.getProductoByID(emision.productoId); // El prodcuto se pone aqui
      }
    },
    async getCategoriasOptions() {
      if (!this.formData.tipo2) return;

      try {
        this.categoriasOptions = await getCategorias(this.formData.tipo2, 0, this.alianzaSingle.id, this.producto.id);
      } catch (error) {
        console.error("Error obteniendo categorías:", error);
        this.categoriasOptions = [];
      }
    },
    async getProductoByID(id) {
      if (!this.formData.emision_id) return;
      try {
        const response = await getProductoByID(id);
        this.producto = response;
        if(this.producto.limiteFamiliares == null) this.formData.redencionPara = "Titular";
      } catch (error) {
        console.error("Error obteniendo producto:", error);
        this.producto = null;
      }
    },
    isBetterware(emision){
      return this.alianzas.filter((a) => (a.id == emision.alianza_intermx_id && a.nombre == "Betterware")).length > 0;
    },
    async getTiposOptions() {
      this.tiposOptions = await getTipos();
    },
    async getBeneficiosByFilters() {
      if (
        !this.formData.tipo2 ||
        !this.formData.categoria ||
        !this.alianza_intermx_id
      ) {
        this.beneficiosOptions = [];
        return;
      }
      this.beneficiosOptions = [];
      let response = await getBeneficiosByFilters({
        tipo: this.formData.tipo2,
        categoria: this.formData.categoria,
        alianza_intermx_id: this.alianza_intermx_id,
        producto_id: this.producto.id
      });
      response.map((e) => {
        if (!e.especial) this.beneficiosOptions.push(e);
      });
    },
    getAlianzaName(id) {
      let alianza = this.alianzas.find((e) => e.id == id);
      return alianza ? alianza.nombre : "";
    },
    getNombreTitularCompleto(titular) {
      if (this.filtro == 1)
        return `${titular.certificado} - ${titular.titular ||
          ""} - ${this.getAlianzaName(titular.alianza_intermx_id)} - Emision: ${
          titular.id
        } ID`;
      else
        return `${titular.titular} - ${titular.num_socio ||
          ""} - ${this.getAlianzaName(titular.alianza_intermx_id)} - Emision: ${
          titular.id
        } ID`;
    },
    async fetchAlianzaByEmisionId() {
      if (!this.formData.emision_id) return;

      try {
        const response = await getAlianzaByEmision(this.formData.emision_id);
        this.alianza_intermx_id = Number(response.alianza_intermx_id);
      } catch (error) {
        console.error("Error al obtener alianza por emision_id:", error);
        this.alianza_intermx_id = null;
      }
    },
    async guardarSolicitudGenerica(){
      if (this.$refs.formBeneficio.validate()) {
        this.loading = true;
        const raw = this.formData.beneficiarios;
        const beneficiariosToArray =
          raw == null ? [] : Array.isArray(raw) ? raw : [raw];

        const payload = {
          emisionId: this.formData.emision_id,
          telefono: this.formData.telefono,

          ...(this.formData.tipo != "Siniestros" && {
            categoria: this.formData.tipo2,
            origen: this.formData.origen,
            beneficioAsistencia: this.formData.beneficio_asistencia_id,
            ...(this.getProveedorId(this.formData.beneficio_asistencia_id) && {
              redimirBeneficioAsistencia: true,
            }),
            redencionPara: this.formData.redencionPara ?? "Titular",
            ...(this.formData.telefono_saldo && {
              celular_saldo: this.formData.telefono_saldo,
            }),
            ...(beneficiariosToArray.length > 0 && {
            beneficiarios: beneficiariosToArray,
          }),
          }),
          ...(this.formData.tipo == "Siniestros" &&{
            siniestro_id: this.formData.siniestro_id,
            emision_id: this.formData.emision_id,
          })
        };

        let servicio = "";
        if (this.formData.tipo != "Siniestros")
          servicio = `v1/solicitud/redencion/${this.alianza_intermx_id}/insert`;
        else servicio = "v1/solicitud/siniestro/insert";

        const config = {
          headers: {
            Authorization: "Bearer " + localStorage.agenteAccessToken,
          },
        };

        mainAxios.post(servicio, payload, config).then((response) => {
          this.loading = false;
          this.$emit("closeDialog");
          this.$toast.success("Solicitud guardada correctamente");
          this.$router.push(
            "/detalles-solicitud/" + response.data.solicitud_id
          );
        }).catch((error) => {
          this.loading = false;
          if (error.response) {
              if (error.response.status === 400) {
                this.$toast.info(
                  `${error.response.data.message}`,
                  {
                    timeout: 5000,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: false,
                    hideProgressBar: true,
                  }
                );
                if(error.response.data.data.solicitud_id){
                  this.solicitudModal = true
                  this.existsolicitudID = error.response.data.data.solicitud_id
                  this.menssageError = error.response.data.message
                }
              } else {
                this.$toast.warning(
                  `Error ${error.response.status}: ${error.response.data
                    .message || error.message}`
                );
              }
            } else if (error.request) {
              this.$toast.error(
                "No hubo respuesta del servidor, intenta más tarde."
              );
            } else {
              this.$toast.error(`Error de cliente: ${error.message}`);
            }
        });
      }
    },
    async guardarSolicitud() {
      if (this.$refs.formBeneficio.validate()) {
        this.loading = true;
        const raw = this.formData.beneficiarios;
        const beneficiariosToArray =
          raw == null ? [] : Array.isArray(raw) ? raw : [raw];

        const payload = {
          emisionId: this.formData.emision_id,
          telefono: this.formData.telefono,

          //estas key solo son en casos diferentes a sinistros
          ...(this.formData.tipo != "Siniestros" && {
            categoria: this.formData.tipo2,
            origen: this.formData.origen,
            beneficioAsistencia: this.formData.beneficio_asistencia_id,
            ...(this.getProveedorId(this.formData.beneficio_asistencia_id) && {
              redimirBeneficioAsistencia: true,
            }),
            redencionPara: this.formData.redencionPara ?? "Titular",
            ...(this.formData.telefono_saldo && {
              celular_saldo: this.formData.telefono_saldo,
            }),
            ...(beneficiariosToArray.length > 0 && {  
            beneficiarios: beneficiariosToArray,
          }),
          }),
          ...(this.formData.tipo == "Siniestros" &&{
            siniestro_id: this.formData.siniestro_id,
            emision_id: this.formData.emision_id,
          })
        };

        let servicio = "";
        if (this.formData.tipo != "Siniestros")
          servicio = "v1/solicitud/redencion/insert";
        else servicio = "v1/solicitud/siniestro/insert";

        const config = {
          headers: {
            Authorization: "Bearer " + localStorage.agenteAccessToken,
          },
        };
        mainAxios
          .post(servicio, payload, config)
          .then((response) => {
            this.loading = false;
            this.$emit("closeDialog");
            this.$toast.success("Solicitud guardada correctamente");
            this.$router.push(
              "/detalles-solicitud/" + response.data.solicitud_id
            );
          })
          .catch((error) => {
            this.loading = false;
            if (error.response) {
              if (error.response.status === 400) {
                this.$toast.info(
                  `${error.response.data.message}`,
                  {
                    timeout: 5000,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: false,
                    hideProgressBar: true,
                  }
                );
                if(error.response.data.data.solicitud_id){
                  this.solicitudModal = true
                  this.existsolicitudID = error.response.data.data.solicitud_id
                  this.menssageError = error.response.data.message
                }
              } else {
                this.$toast.warning(
                  `Error ${error.response.status}: ${error.response.data
                    .message || error.message}`
                );
              }
            } else if (error.request) {
              this.$toast.error(
                "No hubo respuesta del servidor, intenta más tarde."
              );
            } else {
              this.$toast.error(`Error de cliente: ${error.message}`);
            }
          });
      }
      this.loading = false;
    },
    async getSiniestroByAlianzaId() {
      let emision = this.emisiones.find(
        (e) => e.id == this.formData.emision_id
      );
      let alianza_intermx_id = emision ? emision.alianza_intermx_id : null;
      if (alianza_intermx_id == null)
        this.$toast.waring("La emision no tiene alianza asignada");
      else {
        const response = await getSiniestroByAlianzaId(alianza_intermx_id);
        this.siniestros = response.data;
      }
    },
    calculateSumaAsegurada() {
      let result = this.siniestros.find(
        (e) => e.id == this.formData.siniestro_id
      );
      this.sumaAsegurada = this.formatPrice(result.sumaAsegurada);
    },
    formatPrice(price) {
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(price);
    },
    async getTipoSolicitudesForAlianzaId() {
      try {
        let emision = this.emisiones.find(
          (e) => e.id == this.formData.emision_id
        );
        let alianza_intermx_id = emision ? emision.alianza_intermx_id : null;
        if (alianza_intermx_id == null)
          this.$toast.waring("La emision no tiene alianza asignada");
        else {
          const response = await getTipoSolicitudesForAlianzaId(
            alianza_intermx_id
          );
          this.tipoSolicitudes = response.data;
        }
      } catch (error) {
        console.error("Error al obtener tipos de solicitudes:", error);
        this.tipoSolicitudes = [];
      }
    },
    getProveedorId(beneficio_id) {
      let beneficio = this.beneficiosOptions.find((e) => e.id == beneficio_id);
      return beneficio ? (beneficio.codigoProveedorId ? true : false) : false;
    },
    closeModalBeneficiario() {
      this.getBeneficiariosByEmisionId();
      this.dialogBeneficiarios = false;
    },
    toSolicitud(val) {
      if(val) window.open('/detalles-solicitud/' + this.existsolicitudID)
      this.solicitudModal = false
    },
    validateStatusCivil(){
      if(!this.formData.emision_id) return false
      let emision = this.emisiones.find((e) => e.id == this.formData.emision_id)
      let jsonDetalle = JSON.parse(emision.requestJson)
      if(!jsonDetalle.statusCivil){
        this.modalUpdateStatusCivil = true
      } 
    },
    handleSuccessEmision() {
      this.modalUpdateStatusCivil = false;
    },
    onCloseModal() {
      this.modalUpdateStatusCivil = false;
      this.formData.tipo = null;
      this.formData.tipo2 = null;
    },

  },
};
</script>

<style scoped>
.no-scroll {
  overflow: hidden !important;
}
</style>
